import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quantity"
export default class extends Controller {
  static targets = [ "input", "increment", "decrement"]
  static values = { url: String }

  connect() {
    this.inputTarget.dataSet.action = "quantity#update"
  }

  update(event) {
    const quantity = this.inputTarget.value
    const params = new URLSearchParams(this.urlValue)
    params.append({ name: quantity, value: quantity})
  }

  step({ params: { url } }) {
    const quantity = this.inputTarget.value
    const params = new URLSearchParams(url)
    params.append({ name: quantity, value: quantity})

  }
}
